<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-tabs
            keyExpr="code"
            [items]="shifts"
            [selectedItemKeys]="[selectedTab]"
            [showNavButtons]="false"
            (onItemClick)="onShiftButtonClick($event.itemData.code)"
            stylingMode="primary"
            class="mb-2"
        ></dx-tabs>
        <dx-data-grid
            id="gridContainer"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [allowColumnReordering]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="true"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'huddle-grid-state', savingTimeout: 0 }"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            keyExpr="id"
            width="100%"
        >
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Huddle</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                    widget="dxButton"
                    showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{
                    text: 'Reset',
                    icon: 'restore',
                    onClick: resetGrid,
                    stylingMode: 'text'
                }"
                ></dxi-item>
                <!-- Separator -->
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
            </dxo-toolbar>

            <dxi-column
                [dataField]="gridFieldName('employeeName')"
                caption="Employee"
                cellTemplate="employee"
                [minWidth]="200"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('shiftCode')"
                caption="Shift"
                [minWidth]="150"
                [hidingPriority]="1"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('huddleStatus')"
                caption="Huddle Status"
                [minWidth]="150"
                cellTemplate="status"
                [lookup]="{ dataSource: huddleStatusOptions, valueExpr: 'value', displayExpr: 'text' }"
                [headerFilter]="{ dataSource: huddleStatusOptions }"
                [hidingPriority]="2"
            ></dxi-column>
            <dxi-column
                caption="Actions"
                cellTemplate="button"
                alignment="center"
                [minWidth]="150"
            ></dxi-column>
            <div *dxTemplate="let cellInfo of 'status'">
                <contact-status [value]="cellInfo.value | dasherize"
                                [text]="cellInfo.value | capitalCase"></contact-status>
            </div>
            <div *dxTemplate="let cellInfo of 'employee'">
                <user-avatar-email
                    [email]="getCellData(cellInfo).employeeEmail"
                    [name]="getCellData(cellInfo).employeeName"
                    [avatarUrl]="getCellData(cellInfo).employeeAvatar"
                    [employeeId]="getCellData(cellInfo).employeeId"
                ></user-avatar-email>
            </div>
            <div *dxTemplate="let cellInfo of 'button'">
                <dx-button
                    stylingMode="outlined"
                    [text]="isUndoable(getCellData(cellInfo).employeeId) ? 'Undo' : 'Mark as late'"
                    [icon]="isUndoable(getCellData(cellInfo).employeeId) ? 'undo' : undefined"
                    [type]="'default'"
                    (onClick)="isUndoable(getCellData(cellInfo).employeeId)
                    ? undoLate(getCellData(cellInfo).employeeId)
                    : markAsLate(getCellData(cellInfo).employeeId)">
                </dx-button>
            </div>

        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="filterModelName('employeeName')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Employee', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('huddleStatus')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'Huddle',
                    stylingMode: 'filled',
                    items: huddleStatusOptions,
                    valueExpr: 'value',
                    displayExpr: 'text'
                }"
                [colSpan]="1"
            ></dxi-item>
        </dx-form>
    </filter-panel>
</div>
